import { useSetupStore } from '../../store/setupStore';

const CategorySelectionStep = () => {
  const { setup, toggleCategory, setCategoryWeek } = useSetupStore();
  const totalWeeks = Math.ceil(setup.totalClasses / (setup.frequency === 'weekly' ? 1 : 2));

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold text-gray-900">
        Select Feedback Categories
      </h2>
      <p className="text-gray-600">
        Choose the categories you want to receive feedback on and select which week to collect this feedback.
      </p>
      <div className="space-y-4">
        {setup.selectedCategories.map((category) => (
          <div
            key={category.id}
            className="border border-gray-200 rounded-lg p-4 hover:border-emerald-500 hover:shadow-md transition-all duration-200 bg-white"
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <input
                  type="checkbox"
                  checked={category.selected}
                  onChange={() => toggleCategory(category.id)}
                  className="h-4 w-4 text-emerald-600 rounded focus:ring-emerald-500"
                />
                <h3 className="font-medium text-gray-900">{category.name}</h3>
              </div>
              {category.selected && (
                <select
                  value={category.week}
                  onChange={(e) =>
                    setCategoryWeek(category.id, Number(e.target.value))
                  }
                  className="rounded-md border-gray-300 shadow-sm focus:border-emerald-500 focus:ring-emerald-500 text-sm"
                >
                  {Array.from({ length: totalWeeks }, (_, i) => i + 1).map((week) => (
                    <option 
                      key={week} 
                      value={week}
                      disabled={
                        (category.id === 'interaction' && week <= Math.floor(totalWeeks / 3)) ||
                        (category.id === 'difficulty' && week <= Math.floor(totalWeeks / 3)) ||
                        (category.id === 'grading' && week <= Math.floor(totalWeeks / 2))
                      }
                    >
                      Week {week}
                      {(category.id === 'interaction' && week <= Math.floor(totalWeeks / 3)) ||
                       (category.id === 'difficulty' && week <= Math.floor(totalWeeks / 3)) ||
                       (category.id === 'grading' && week <= Math.floor(totalWeeks / 2))
                        ? ' (Not Recommended)'
                        : ''}
                    </option>
                  ))}
                </select>
              )}
            </div>
            <p className="mt-2 text-sm text-gray-500 ml-7">
              {category.description}
              {category.id === 'interaction' && (
                <span className="block mt-1 text-emerald-600 font-medium">
                  Recommended: Later weeks for better teacher-student relationship assessment
                </span>
              )}
              {category.id === 'difficulty' && (
                <span className="block mt-1 text-emerald-600 font-medium">
                  Recommended: Later weeks when students have experienced course challenges
                </span>
              )}
              {category.id === 'grading' && (
                <span className="block mt-1 text-emerald-600 font-medium">
                  Recommended: After mid-semester when students have received assessments
                </span>
              )}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CategorySelectionStep;